import { render, staticRenderFns } from "./topStatistics.vue?vue&type=template&id=259e34cc&"
import script from "./topStatistics.vue?vue&type=script&lang=js&"
export * from "./topStatistics.vue?vue&type=script&lang=js&"
import style0 from "./topStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports